import type { ReactNode } from 'react'

export interface VehicleDocumentColumn<Row> {
  label: string
  render: (row: Row, index: number) => ReactNode
  className?: string
}

interface VehicleDocumentTableProps<Row> {
  rows: Row[]
  columns: Array<VehicleDocumentColumn<Row>>
  emptyMessage?: string
}

export default function VehicleDocumentTable<Row>({ rows, columns, emptyMessage = 'No vehicles provided.' }: VehicleDocumentTableProps<Row>) {
  if (rows.length === 0) {
    return <div className="rounded border border-slate-300 px-3 py-4 text-sm text-slate-500">{emptyMessage}</div>
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-slate-300 text-left text-sm">
        <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.22em] text-slate-500">
          <tr>
            {columns.map((column) => (
              <th key={column.label} className={`border-b border-slate-300 px-3 py-2 font-semibold ${column.className ?? ''}`.trim()}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className="align-top even:bg-slate-50/60">
              {columns.map((column) => (
                <td key={column.label} className={`border-b border-slate-200 px-3 py-3 text-slate-900 ${column.className ?? ''}`.trim()}>
                  {column.render(row, index)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
